import PropTypes from 'prop-types';

import { Main as MainMarkup } from '@/components/ui/layouts/main/Main';

export const Main = ({ children, breadcrumbs, layout, language }) => {
  return (
    <MainMarkup layout={layout} breadcrumbs={breadcrumbs} language={language}>
      {children}
    </MainMarkup>
  );
};

Main.propTypes = {
  children: PropTypes.node.isRequired,
};
